import React from 'react'
import { useFeatureNumbersChart } from './hook'
import {
  Chart as ChartJS,
  RadialLinearScale,
  PointElement,
  LineElement,
  Filler,
  Tooltip,
  Legend,
} from 'chart.js'
import { Radar } from 'react-chartjs-2'

type Props = {
  communicationImpact: number
  teamImpact: number
  interactingPeopleImpact: number
  closenessImpact: number
  easinessImpact: number
}
ChartJS.register(
  RadialLinearScale,
  PointElement,
  LineElement,
  Filler,
  Tooltip,
  Legend
)

export const FeatureNumbersChart = (props: Props): JSX.Element => {
  const chartConfig = useFeatureNumbersChart(props)

  return (
    <div className="w-[70vw] lg:w-[21.9vw] lg:h-[17.2vw]">
      <Radar data={chartConfig.data} options={chartConfig.options} />
    </div>
  )
}
